<template lang='pug'>
  .rewards-section
    .title.h3(v-text='title')
    .sessions(v-if='isGuestUser')
      i18n.sessions-content(path='account.rewardsBoutique.rewardsSection.signInToRedeem' tag='p')
        //- can be switched to AuthPopup once feature flag is removed
        a.link.sign-in-link(:href='signInLink' place='signInLink' v-t='"account.rewardsBoutique.rewardsSection.signIn"')
        a.link.sign-up-link(:href='signUpLink' place='signUpLink' v-t='"account.rewardsBoutique.rewardsSection.register"')
    .rewards
      template(v-for='reward in rewards')
        reward(
          :reward='reward'
          :is-guest-user='isGuestUser'
          :is-reward-added-to-bag='isRewardAddedToBag(reward)'
        )
</template>

<script>
import Reward from './reward.vue'

export default {
  components: {
    Reward
  },

  props: {
    title: String,
    rewards: Array,
    cartSamples: Array,
    isGuestUser: Boolean
  },

  computed: {
    signInLink: () => '#authentication',
    signUpLink: () => '#authentication'
  },

  methods: {
    isRewardAddedToBag (reward) {
      return reward.sampleId && this.cartSamples.includes(reward.sampleId.toString())
    }
  }
}
</script>

<style lang='scss' scoped>
  .rewards-section {
    margin-bottom: 30px;
  }

  .title {
    @include font-weight-bold;
    display: flex;
    margin-bottom: 10px;
    text-align: center;
    text-transform: uppercase;

    &::before, &::after {
      content: '';
      flex: 1 1;
      border-bottom: 1px solid $black;
      margin-bottom: auto;
      margin-top: auto;
    }

    &::after {
      margin-left: 6px;
    }

    &::before {
      margin-right: 6px;
    }
  }

  .sessions {
    text-align: center;
  }

  .rewards {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @include media-breakpoint-up(sm) {
      justify-content: center;
    }
  }

  .sign-in-link, .sign-up-link {
    text-decoration: underline;
  }
</style>
